import { render, staticRenderFns } from "./writeReview.vue?vue&type=template&id=6468eab2&"
import script from "./writeReview.vue?vue&type=script&lang=js&"
export * from "./writeReview.vue?vue&type=script&lang=js&"
import style0 from "./writeReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports